import React from "react";
import {withStyles} from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {NotificationContainer, NotificationManager} from "react-notifications";
import {
    communicationPlan,
    communicationPlanRevision, deleteCommunicationPlan,
    saveOrUpdateCommunicationPlan
} from "../../util/CommunicationPlanModuleApiUtils";
import { t } from '../../i18n';
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import {AddCircleOutlineTwoTone} from "@material-ui/icons";
import moment from "moment";
import CardContent from "@material-ui/core/CardContent";
import Modal from "@material-ui/core/Modal";
import CommunicationPlanRevisionModal from "./CommunicationPlanRevisionModal";
import {BlueButton} from "../common/ButtonsConstants";
import MuiTable from "../common/MuiTable";
import {Spinner} from "../common/Spinner";
import {exportReport, importFile} from "../../util/ApiUtils";
import * as CommonUtils from "../../util/CommonUtils";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    { title: t('communication.columns.what'), field: 'what', type: "textarea" },
    { title: t('communication.columns.when'), field: 'when', type: "textarea" },
    { title: t('communication.columns.withWhom'), field: 'withWhom', type: "textarea" },
    { title: t('communication.columns.how'), field: 'how', type: "textarea" },
    { title: t('communication.columns.who'), field: 'who', type: "textarea" },
];

class CommunicationPlan extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: true,
            show: false,
            latestRevision: {}
        };
        this.loadCommunicationPlan = this.loadCommunicationPlan.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onFileImport = this.onFileImport.bind(this);
        this.fileUploadHandler = this.fileUploadHandler.bind(this);
    }

    componentDidMount() {
        this.loadCommunicationPlan();
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal(updatedRevision) {
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    onFileImport(event) {
        console.log('event.target.files[0]', event.target.files[0]);
        this.setState({
            selectedFile: event.target.files[0],
        });
    }

    fileUploadHandler() {
        importFile("/communication-plan/import", this.state.selectedFile, []);
    }

    loadCommunicationPlan() {
        communicationPlan()
            .then(response => {
                console.log('loaded', response);
                this.setState({
                    data: response,
                });
                communicationPlanRevision()
                    .then( revisionResponse => {
                        this.setState({
                            latestRevision: revisionResponse,
                            isLoading: false,
                        });
                    })
                    .catch(error => {
                        console.log(error);
                    });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleDelete(data) {
        console.log('delete', data);
        deleteCommunicationPlan(data)
            .then(() => {
                this.loadCommunicationPlan();
                NotificationManager.success(t('app.notifications.success'), t('messages.communicationPlanUpdated'), 5000);
            }).catch(
            error => {
                console.log("error");
                console.log(error);
                NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
            });
    }

    isValid(newData) {
        /*let isValid = newData.name && newData.name !== '' && newData.description && newData.description !== '';
        if (!isValid) {
            NotificationManager.error('Error', 'Validation Error. Name and Description are required fields', 5000);
        }
        return isValid;*/
        // for now its always valid
        return true;
    }

    handleAddRow() {
        this.state.data.push({
            immutable: false,
        });
        console.log('pushed', this.state.data);
        this.setState({ state: this.state });
    }

    handleSubmit(data) {
        saveOrUpdateCommunicationPlan(data)
            .then(() => {
                this.loadCommunicationPlan();
                NotificationManager.success(t('app.notifications.success'), t('messages.communicationPlanUpdated'), 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    render() {
        const { state } = this;

        if (state.isLoading) {
            return <Spinner/>;
        }

        const isRevision = state.latestRevision.completedBy && state.latestRevision.completedOn;
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                { t('communication.title') }
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <Card className={classes.card}>
                    <CardHeader
                        action={
                            <BlueButton
                                 variant="contained"
                                 color="secondary"
                                 startIcon={<AddCircleOutlineTwoTone/>}
                                 onClick={this.showModal}
                                 size="small"
                                 style={{marginRight: '10px'}}
                                 disabled={isAuditor || isViewer}
                             >
                                { t('common.add') }
                             </BlueButton>
                        }
                        title={
                            (isRevision &&
                                (<span style={{color: "darkblue"}}>
                                    <p>
                                        <b><span>{t('context.common.revision')} {state.latestRevision.number}: {moment(state.latestRevision.date).format('DD/MM/YYYY')}</span></b>
                                    </p>
                                </span>)
                            )
                        }
                        subheader={
                            isRevision &&
                            <span>
                                <p>{t('communication.completedBy')}: {state.latestRevision.completedBy}</p>
                                <p>{t('communication.completedOn')}: {moment(state.latestRevision.completedOn).format('DD/MM/YYYY')}</p>
                            </span>
                        }
                    />
                    <CardContent>
                        <MuiTable
                            title={ t('communication.tableTitle') }
                             columns={columns}
                             data={state.data}
                             onAdd={this.handleSubmit}
                             onUpdate={this.handleSubmit}
                             onDelete={this.handleDelete}
                             exportButton={!isDemo && !isViewer}
                             onExport={() => exportReport('/communication-plan/export')}
                             isValid={this.isValid}
                             pageSize={10}
                             allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                         />
                     </CardContent>
                     {(this.props.isAuthenticated && ['admin@statuo.com.au', 'tanya.happy@live.com'].includes(this.props.currentUser.username)) &&
                         <div>
                            <h4>{ t('communication.importHeading') }</h4>
                             <TextField
                                 variant="outlined"
                                 margin="normal"
                                 required
                                 fullWidth
                                 id="file"
                                 name="file"
                                 autoFocus
                                 disabled={isAuditor || isViewer}
                                 onChange={this.onFileImport}
                                 type="file"
                             />
                             <Button
                                 type="submit"
                                 fullWidth
                                 variant="contained"
                                 color="primary"
                                 onClick={() => this.fileUploadHandler()}
                             >
                                { t('communication.importButton') }
                                </Button>
                         </div>
                     }
                 </Card>
             </Paper>
            <Modal
                 aria-labelledby="simple-modal-title"
                 aria-describedby="simple-modal-description"
                 open={state.show}
                 onClose={() => this.closeModal(null)}
             >
                 <CommunicationPlanRevisionModal latestRevisionDto={state.latestRevision} postSubmit={this.closeModal}/>
             </Modal>
             <NotificationContainer/>
         </div>;
     }
 }

 export default withStyles(classes)(CommunicationPlan);
